/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useIntl } from 'react-intl';
import { Tree } from 'antd';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

import { useStyles } from '~src/hooks/useStyles';
import IconButton from '~components/_common/IconButton/IconButton';
import { styleFn } from './PublicShare.style';
import navigationItems from '~src/data/navigationItems';
import { SimpleObject } from '~src/types';
import { TREE_MIN_WIDTH } from '~src/config';

const sharedNavItem = navigationItems.find(
  (navItem) => navItem.key === 'shared-with-me'
) as typeof navigationItems[0];

const mockNavigationItems: SimpleObject<typeof sharedNavItem> = {
  home: {
    key: 'home',
    section: '',
    nameTerm: 'home',
    icon: ['fad', 'house'],
    color: 'darkGray',
    path: '',
  },
  shared: sharedNavItem,
};

/** A copy of the structure in `LeftSideView`, non functional */
export const MockLeftNavigation = () => {
  const styles = useStyles(styleFn);
  const intl = useIntl();

  return (
    <div css={styles.leftTreeContainer}>
      <Tree.DirectoryTree
        css={{
          width: ['30vw', 'max-content'],
          minWidth: [
            `${TREE_MIN_WIDTH - 10}px`,
            `max(${TREE_MIN_WIDTH - 10}px, 18.9vw)`,
          ],
        }}
        className={
          window.sessionStorage.getItem('appState') !== 'timeMachine'
            ? 'draggable-tree'
            : 'timeMachine-tree'
        }
        defaultExpandAll
        defaultSelectedKeys={[sharedNavItem.key]}
        treeData={[
          {
            title: intl.formatMessage({
              id: mockNavigationItems.home.nameTerm,
            }),
            key: mockNavigationItems.home.key,
            icon: (
              <IconButton
                icon={mockNavigationItems.home.icon as IconProp}
                color={mockNavigationItems.home.color}
                customStyle={styles.leftTreeIcon}
                backgroundOff
              />
            ),
            children: [
              {
                title: intl.formatMessage({
                  id: mockNavigationItems.shared.nameTerm,
                }),
                key: mockNavigationItems.shared.key,
                icon: (
                  <IconButton
                    icon={mockNavigationItems.shared.icon as IconProp}
                    color={mockNavigationItems.shared.color}
                    customStyle={styles.leftTreeIcon}
                    backgroundOff
                  />
                ),
              },
            ],
          },
        ]}
      />
    </div>
  );
};
